// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__WHDpQ","footer":"ReportModalFilter_footer__aGJg4"};